import Vue from "vue";
import App from "./App.vue";
import Vuex from "vuex";
import router from "./router";
import store from "./store";
import axios from "./axios";
import api from "./plugs/api";
import "./assets/style.css";

Vue.prototype.$api = api;
Vue.prototype.$axios = axios;

Vue.prototype.openUrl = function(push, query = {}) {
  //const year = store.state.year;
  const sellid = store.state.sellid;
  if (sellid) {
    query.sellid = sellid;
  }
  router.push({ push, query });
};

import {
  Button,
  Icon,
  Tab,
  Tabs,
  Grid,
  GridItem,
  Image,
  RadioGroup,
  Radio,
  Step,
  Steps,
  Col,
  Row,
  Skeleton,
  Progress,
  Popup,
  Swipe,
  SwipeItem,
  Card,
  Tag,
  Divider,
  NavBar,
  Sidebar,
  SidebarItem,
  List,
  Cell,
  CellGroup,
  Sticky,
  Dialog,
  Toast,
  Notify
} from "vant";

Vue.use(Button);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Image);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Col);
Vue.use(Row);
Vue.use(Skeleton);
Vue.use(Progress);
Vue.use(Popup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Card);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(NavBar);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(List);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Sticky);

Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Notify);

Vue.use(Vuex);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
